import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWhiteboard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWhiteboard1"><Path d="M12.75 2H11.25V4H2V19H6.95943L6.05132 21.7243L7.47434 22.1987L8.54057 19H11.25V21H12.75V19H15.4594L16.5257 22.1987L17.9487 21.7243L17.0406 19H22V4H12.75V2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWhiteboard1;
